import {MaterialType} from '../components/cards/FacilityCard'
import {PillTypes} from '../components/pills/Pill'

export const checkIfImageExists = (
  url: string,
  callback: (arg: boolean) => void
) => {
  if (!url) {
    return callback(false)
  }
  const img = new Image()
  img.src = url

  if (img.complete) {
    return callback(true)
  } else {
    img.onload = () => {
      return callback(true)
    }

    img.onerror = () => {
      return callback(false)
    }
  }
}

export const checkIsEmptyString = (value: string): boolean => {
  return value.trim() === ''
}

export const capitalizeFirstLetter = (word: string): string => {
  if (!word.length) return ''
  const firstLetter = word.charAt(0)
  const restOfWord = word.substring(1)
  return firstLetter.toUpperCase() + restOfWord
}

export type GenericObject = {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [x: string]: any;
}

export const getPillTypeByMaterial = (material: MaterialType): PillTypes => {
  switch (material) {
    case 'paper':
      return 'warning'
    case 'plastic':
      return 'green'
    default:
      return 'green'
  }
}
